<template>
  <!-- <div>
    <h1>Login</h1>
    <input type="text" name="" id="" class="form-control" v-model="email">
    <button class="btn btn-primary" @click="loginform">Login</button>
  </div> -->
  <!-- https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/ -->
  <div class="text-center login-form">
    <form class="form-signin" @submit.prevent="onSubmit">
      <!-- <img class="mb-4" src="../../assets/brand/bootstrap-solid.svg" alt="" width="72" height="72"> -->
      <!-- <img class="mb-4" src="../assets/img/logo/logo-dame-una-mano_imageonly_purple.svg" alt="" width="72" height=""> -->
      <h1 class="h3 mb-3 font-weight-normal" style="margin-bottom: 0;">Log In</h1>

      <label for="inputEmail" class="sr-only">Email</label>
      <input type="email" id="inputEmail" class="form-control mt-3" placeholder="Email" required autofocus v-model="email">
      <label for="inputPassword" class="sr-only">Password</label>
      <input type="password" id="inputPassword" class="form-control" placeholder="Password" required v-model="password">
      <!-- <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me"> Remember me
        </label>
      </div> -->
      <button class="btn btn-lg btn-primary btn-block" type="submit">Sign In</button>
      <p v-if="loginError" class="pt-2"><strong>Hmm sorry, there was a problem logging in. Please make sure your email and password are correct and try again!</strong></p>
      <!-- <p class="mt-5 mb-5 text-muted">&copy; 2017-2018</p> -->

      <!-- <p style="line-height: 1.4; font-size: 80%;">Want to try a demo coach and runner experience? Log in with the email myrundash@gmail.com and password myrundash</p> -->
      <p class="pt-4" style="line-height: 1.4; font-size: 85%; margin-bottom: 1px; font-weight: 700;">Want to demo the coach & runner experience?</p>
      <p style="line-height: 1.4; font-size: ; color: #007bff; cursor: pointer;" @click.prevent="demoLogin()">Log into the demo account</p>
      <!-- <button class="btn btn-lg btn-primary btn-block" @click.prevent="demoLogin()">Log into demo account</button> -->

      <p class="pt-2">Don't have a profile? <router-link to="/register" class="">Sign Up</router-link></p>
      <p class=""><router-link :to="{ name: 'Password Reset Request' }">Forgot Password</router-link></p>
      <!-- <p class="pt-4 pb-5 text-muted">¿Preguntas? 350-4775478</p> -->
    </form>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        email: '',
        password: '',

        loginError: false,
      }
    },
    methods: {
      loginform () {
        console.log(this.email);
        if (this.email) {
          this.$store.dispatch('logMeIn', this.email);
        }
      },
      onSubmit () {
        const formData = {
          email: this.email,
          password: this.password,
        }
        console.log(formData)
        // axios.post('https://vuejs-http-cf9e8.firebaseio.com/users.json', formData)
        // axios.post('/users.json', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', {
        // axios.post('http://127.0.0.1:8000/api-token-auth/', {
        //   username: formData.email,
        //   password: formData.password,
        // })
        //   .then(res => console.log(res))
        //   .catch(error => console.log(error))
        this.$store.dispatch('login', {email: this.email, password: this.password})
          .then(() => {
            console.log('Successful login!')
            // console.log(axios.defaults.baseURL)
          })
          .catch(error => {
            console.log('problemoo logging in')
            this.loginError = true
          })
      },
      demoLogin() {
        this.$store.dispatch('login', {email: 'myrundash@gmail.com', password: 'myrundash'})
          .then(() => {
            console.log('Successful demo login!')
            // console.log(axios.defaults.baseURL)
          })
          .catch(error => {
            console.log('problemoo logging into demo')
            this.loginError = true
          })
      },
    },
  }
</script>

<style>
/* Bootstrap sign up form */
/* https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/signin.css */

  .login-form {
    height: calc(100vh - 30px); /* There is a 15px margin top and bottom */
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f5f5f5;
  }

  .form-signin {
    width: 100%;
    max-width: 330px;
    /* min-width: 300px; */
    padding: 15px;
    margin: auto;
  }
  .form-signin .checkbox {
    font-weight: 400;
  }
  .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }
  .form-signin .form-control:focus {
    z-index: 2;
  }
  .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  @media (max-width: 768px) {
    .login-form {
      height: auto;
      /* display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 40px; */
      padding-left: 30px;
      background-color: #f5f5f5;
      background-color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/myrundash/LoginForm.vue